import { useEffect, useState } from "react";
import Api from "../openapi";
import { AffiliateResponse } from "../openapi/client";

export default function useAffiliates() {
  const [affiliateList, setAffiliateList] = useState<AffiliateResponse[]>([]);
  useEffect(() => {
    const getAffiliates = async () => {
      try {
        const res = await Api.Affiliate.listAffiliates();
        setAffiliateList(res.data);
      } catch (error) {}
    };
    getAffiliates();
  }, []);
  return affiliateList;
}
